import { postImpersonateFailed } from "./actions";

import { call, put, takeEvery } from "redux-saga/effects";

import { POST_IMPERSONATE } from "./actionTypes";

import { postCall } from "../../../helpers/fakebackend_helper";

function* postImpersonateHanlder({ payload: data }) {
  try {
    let url = `account/impersonate/login`;
    let responseJSON = yield call(postCall, url, data);
    localStorage.setItem("impersonationMode", true)
    if(localStorage.getItem("authUser") != null && localStorage.getItem("authUser") !== undefined){
      localStorage.setItem("secondaryStorage", localStorage.getItem("authUser"))
    }else {
      localStorage.setItem("isAuthProtected", true)
    }
    localStorage.setItem("authUser", JSON.stringify(responseJSON))
    if(responseJSON.userType === 'ORGANIZATION'){
      window.location = '/dashboard'
    }else if(responseJSON.userType === 'RECRUITER'){
      window.location = '/recruiter/dashboard'
    }
    localStorage.setItem('reloadMessage', 'reload');
  } catch (error) {
    yield put(postImpersonateFailed(error));
  }
}

function* impersonateSaga() {
  yield takeEvery(POST_IMPERSONATE, postImpersonateHanlder);
}

export default impersonateSaga;
